export default __webpack_public_path__ + "e6aea16a65e58222fa48c29f91288a8a.png";